import React, { useContext, useEffect, useState } from 'react';
import DateConverter from '../Tools/DateConverter';
import msg from '../Tools/MsgUtils';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function Reportes(props) {
    const {loading,setLoading} =useContext(ContextGloball)
    const { regional } = props;
    const [sucursales, setSucursale] = useState([]);
    const actualizarReporte = () => {
        setLoading(true);
        fetch(`${server}/reporte/getReporte`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                console.log(data);
                setSucursale(data.ok);
            })
            .catch(err => msg.msgError(err));
    }
    function mostrarSuma(cruda, marinada) {
        if (cruda < 0 && marinada < 0) {
            return '?'
        } else {
            return cruda + marinada
        }
    }
    useEffect(() => {
        setLoading(true);
        fetch(`${server}/reporte/getReporte`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                setSucursale(data.ok);
            })
            .catch(err => msg.msgError(err));
    }, [])
    return (
        <div className=''>
            <div className="container-fluid bg-dark bg-gradient">
                <div className='row row-cols-3 row-cols-md-2 g-0'>
                    <div className='col my-auto' style={{maxWidth:'600px'}}>
                        <div className='text-light fw-bold px-2 fs-4'>Reporte de Pollo(octavo) Actual</div>
                    </div>
                    <div className='col my-auto text-end' style={{maxWidth:'100px'}}>
                        <a className="btn btn-light btn-sm" onClick={actualizarReporte} >
                            <i className="fa-solid fa-arrows-rotate "></i> 
                            <span className='d-none d-sm-inline'>Actualizar</span></a>
                    </div>
                </div>
            </div>
            <div className='container-fluid table-responsive py-2'>
                <table className="table table-sm table-striped table-hover">
                    <thead className='bg-dark text-light'>
                        <tr>
                            <th scope="col">Sucursal {DateConverter.formatoFecha(new Date())}</th>
                            <th scope="col">Alas</th>
                            <th scope="col">Piernas</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sucursales.map((item) => {
                            return (
                                <tr key={item.ID_SUCURSAL}>
                                    <th scope="row">{item.SUCURSAL}</th>
                                    <td>{item.piernas_crudas !== undefined ? mostrarSuma(item.alas_crudas, item.alas_marinadas) : 'err'}</td>
                                    <td>{item.piernas_crudas !== undefined ? mostrarSuma(item.piernas_crudas, item.piernas_marinadas) : 'err'}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Reportes
